import { Paper, Stack, Typography, useTheme } from "@mui/material";
import { WorkflowOverviewStatsQuery } from "generated-graphql/graphql";
import { KeyMetric } from "./KeyMetric";

export function WorkflowOverviewKeyMetrics({
  data,
  loading,
}: {
  data?: WorkflowOverviewStatsQuery["workflowOverviewSeasonSummary"];
  loading: boolean;
}) {
  const theme = useTheme();
  return (
    <Paper
      sx={{
        height: "100%",
        width: "100%",
        overflowY: "auto",
        py: theme.spacing(2),
        px: theme.spacing(3),
      }}
      elevation={0}
    >
      <Stack direction="column" spacing={theme.spacing(2)}>
        <Typography variant="body1" color={theme.palette.text.secondary}>
          Key Metrics
        </Typography>
        <KeyMetric
          name="In Error"
          value={data?.workflowsCountError}
          loading={loading}
        />
        <KeyMetric
          name="Wait for All"
          value={data?.workflowsCountWaitForAll}
          loading={loading}
        />
        <KeyMetric
          name="In Manual"
          value={data?.workflowsCountHuman}
          loading={loading}
        />
      </Stack>
    </Paper>
  );
}
